var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Globe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 11.9997C20 7.57141 16.4284 4 12 4C7.57156 4 4 7.57141 4 11.9997M20 11.9997C20 16.4279 16.4284 19.9993 12 19.9993C7.57156 19.9993 4 16.4279 4 11.9997M20 11.9997H4M10.3716 4.94218C7.80267 9.23089 7.80267 14.7693 10.3716 19.058C11.1236 20.314 12.8773 20.314 13.6293 19.058C16.1982 14.7693 16.1982 9.23089 13.6293 4.94218C12.8764 3.68624 11.1236 3.68624 10.3716 4.94218Z",
    stroke: "#888C95",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/Globe.103a4b49974c308f8c9ca1a90cbd07ce.svg";
export { ForwardRef as ReactComponent };